export const SHELL_PROTOCOL_OPERATIONS_NS = 'ETS.ShellService.Shell.Protocol.Operations';
